module.exports = __webpack_public_path__ + "img/businessman.67e81333.svg";